// Helpers for bond portfolio assets (asset_type "bonds" with
// bond_holdings of {label, invested_inr, current_inr}).

/** "3 bonds · invested ₹3,50,000" one-line summary. */
export function bondSummary(asset) {
  const holdings = asset?.bond_holdings || [];
  const count = `${holdings.length} bond${holdings.length === 1 ? "" : "s"}`;
  const invested = holdings.reduce((s, h) => s + (Number(h.invested_inr) > 0 ? Number(h.invested_inr) : 0), 0);
  if (!invested) return count;
  return `${count} · invested ₹${Math.round(invested).toLocaleString("en-IN")}`;
}

/** Aggregate % gain vs. invested; null when no invested amounts are set. */
export function bondGainPercent(asset) {
  let invested = 0;
  let current = 0;
  for (const h of asset?.bond_holdings || []) {
    const inv = Number(h.invested_inr);
    const cur = Number(h.current_inr);
    if (!(inv > 0) || !(cur > 0)) continue;
    invested += inv;
    current += cur;
  }
  if (!invested) return null;
  return ((current - invested) / invested) * 100;
}
